<template>
  <div class="login-container biometric-await flex flex--column flex--start">
    <h1>זיהוי ביומטרי</h1>
    <img :src="biometricIconPath" alt="biometric icon" />
    <h3>כבר מתחברים...</h3>
  </div>
</template>

<script>
export default {
  name: "Biometric",
  computed: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    biometricIconPath() {
      return this.isIOS
        ? "/assets/img/svg/faceid.svg"
        : "/assets/img/svg/fingerprint.svg";
    }
  }
};
</script>
